const configs = import.meta.glob('../../config/*.json', { eager: true });

function deepMerge(target: Record<string, any>, source: Record<string, any>): Record<string, any> {
  if (typeof target !== 'object' || typeof source !== 'object' || target === null || source === null) {
    return source;
  }
  const result = { ...target };
  Object.keys(source).forEach(key => {
    if (key in target) {
      result[key] = deepMerge(target[key], source[key]);
    } else {
      result[key] = source[key];
    }
  });
  return result;
}

const configMap = Object.entries(configs).reduce(
  (acc, [path, mod]: [any, any]) => {
    const key = path.match(/([\w-]+)\.json$/)![1];
    acc[key] = mod.default;
    return acc;
  },
  {} as Record<string, any>
);

const env = import.meta.env.VITE_REACT_APP_ENV || 'develop';

const defaultConfig = configMap.default || {};
const envConfig = configMap[env] || {};

const mergedConfig = deepMerge(defaultConfig, envConfig);

export default mergedConfig;
